"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Store = function Store(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="21" height="23"' : 'width="100%"';
  var title = 'Store Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" ").concat(iconSize, " viewBox=\"0 0 21 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <title>").concat(title, "</title>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2.563V17.511L1.954 18.462V11.29L7.994 14.257V21.429L9.918 22.379V7.431L1.066 3.08L0 2.563ZM11.872 11.636V21.429L20.842 17.022V7.258L11.872 11.636Z\" fill=\"").concat(color, "\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.8721 6.164V9.447L20.6351 5.156L10.5701 0.23L4.76709 2.68L11.8721 6.165V6.164Z\" fill=\"").concat(color, "\"/>\n    </svg>\n  ");
};

var _default = Store;
exports["default"] = _default;